/* eslint-disable no-useless-escape */
/**
 * 问卷调查弹窗
 */
import { add_corp_info } from '@/services/admin'
export default {
  name: 'questionnaire',
  data() {
    const nameValidate = (rule, value, cb) => {
      if (!this.infoForm.firstname && !this.infoForm.lastname) {
        cb(new Error(this.$t('need_firstname_or_lastname')))
      } else if (/\d/g.test(value)) {
        return cb(new Error(this.$t('no_permit_number')))
      } else {
        cb()
      }
    }
    const companyValidate = (rule, value, cb) => {
      if (/\d/g.test(value)) {
        return cb(new Error(this.$t('no_permit_number')))
      } else {
        cb()
      }
    }
    const phoneValidate = (rule, value, cb) => {
      if (!/^[\d\+\-\(\)#]{6,20}$/.test(value)) {
        cb(new Error(this.$t('invalid_phone_form')))
      } else {
        cb()
      }
    }
    return {
      visible: localStorage.question == 1 || false,
      startLoading: false,
      // 中文环境下问卷调查表单
      quesForm: {
        title: '', // 职位
        userNum: '', // 用户数量
        industry: '', // 您的公司行业
        howKnowCCB: [], // 您如何获知名片全能王企业版？
        whichCCBFunc: [] // 名片全能王哪些功能更加吸引您？
      },
      // 问卷调查表单校验规则
      quesRules: {
        title: [{ required: true, message: this.$t('field_empty_error'), trigger: 'change' }],
        userNum: [{ required: true, message: this.$t('field_empty_error'), trigger: 'change' }],
        howKnowCCB: [{ required: true, message: this.$t('field_empty_error'), trigger: 'change' }]
      },
      // 职位-选项
      titleOptions: [
        this.$t('questionnaire_register_1_1'), // 总裁、CEO
        this.$t('questionnaire_register_1_2'), // 决策者
        this.$t('questionnaire_register_1_3') // 使用者
      ],
      // 使用用户数量-选项
      userNumOptions: [
        {
          label: this.$t('questionnaire_register_2_1'),
          value: 2
        },
        {
          label: this.$t('questionnaire_register_2_2'),
          value: 5
        },
        {
          label: this.$t('questionnaire_register_2_3'),
          value: 9
        },
        {
          label: this.$t('questionnaire_register_2_4'),
          value: 29
        },
        {
          label: this.$t('questionnaire_register_2_5'),
          value: 30
        }
      ],
      // 您的公司行业-选项
      industryOptions: [
        this.$t('user_question_cn_1_1'),
        this.$t('user_question_cn_1_2'),
        this.$t('user_question_cn_1_3'),
        this.$t('user_question_cn_1_4'),
        this.$t('user_question_cn_1_5'),
        this.$t('user_question_cn_1_6'),
        this.$t('user_question_cn_1_7'),
        this.$t('user_question_cn_1_8'),
        this.$t('user_question_cn_1_9'),
        this.$t('user_question_cn_1_10'),
        this.$t('user_question_cn_1_11')
      ],
      // 您如何获知名片全能王企业版-选项
      howKnowCCBOptions: [
        this.$t('user_question_cn_2_1'),
        this.$t('user_question_cn_2_2'),
        this.$t('user_question_cn_2_3'),
        this.$t('user_question_cn_2_4')
      ],
      // 名片全能王哪些功能更加吸引您-选项
      whichCCBFuncOptions: [
        {
          label: this.$t('user_question_cn_3_1'),
          value: '1'
        },
        {
          label: this.$t('user_question_cn_3_2'),
          value: '2'
        },
        {
          label: this.$t('user_question_cn_3_3'),
          value: '3'
        }
      ],
      // 英文环境下表单
      infoForm: {
        firstname: '', // 名
        lastname: '', // 姓
        whichCCBFunc: [], // 名片全能王哪些功能更加吸引您？
        phone: '', // 电话
        userNumEn: '', // 您希望有多少用户使用此服务？
        company: '', // 公司
        howKnowUs: '' // 怎么知道我们的
      },
      infoRules: {
        firstname: [{ validator: nameValidate, trigger: 'blur' }],
        lastname: [{ validator: nameValidate, trigger: 'blur' }],
        whichCCBFunc: [
          { required: true, message: this.$t('field_empty_error'), trigger: 'change' }
        ],
        phone: [
          { required: true, message: this.$t('field_empty_error'), trigger: 'blur' },
          { validator: phoneValidate, trigger: 'blur' }
        ],
        userNumEn: [{ required: true, message: this.$t('field_empty_error'), trigger: 'change' }],
        company: [
          { required: true, message: this.$t('field_empty_error'), trigger: 'blur' },
          { validator: companyValidate, trigger: 'blur' }
        ]
      },
      // 您希望有多少用户使用此服务-选项
      userNumEnOptions: [
        {
          label: this.$t('user_question_en_2_1'),
          value: 5
        },
        {
          label: this.$t('user_question_en_2_2'),
          value: 29
        },
        {
          label: this.$t('user_question_en_2_3'),
          value: 30
        }
      ]
    }
  },
  watch: {
    visible(newV) {
      if (newV) {
        this.$log.trace('CC_GUIDE_FIRSTLOGIN_PAGE')
      }
    }
  },
  mounted() {},
  methods: {
    startUse() {
      // 中文
      if (this.$i18n.locale === 'zh-cn' || this.$i18n.locale === 'zh-tw') {
        this.$refs.quesForm.validate(valid => {
          if (!valid) return
          const params = {
            company_industry: this.quesForm.industry,
            reason: this.quesForm.whichCCBFunc.join(';'),
            user_source: this.quesForm.howKnowCCB.join(';'),
            plan_count: this.quesForm.userNum,
            creator_position: this.quesForm.title
          }
          add_corp_info({}, params)
            .then(() => {
              this.$emit('submit')
              this.$log.action('CC_SUBMIT_QUESTIONNAIRE', { data: params })
              this.visible = false
              localStorage.question = ''
            })
            .catch(() => {
              localStorage.question = ''
            })
        })
      } else if (this.$i18n.locale === 'en-us') {
        // 英文
        this.$refs.infoForm.validate(valid => {
          if (!valid) return
          const params = {
            reason: this.infoForm.whichCCBFunc.join(';'),
            plan_count: this.infoForm.userNumEn,
            user_source: this.infoForm.howKnowUs,
            corp_name: this.infoForm.company,
            contact: this.infoForm.phone,
            user_name: `${this.infoForm.firstname || ''}${
              this.infoForm.lastname ? ` ${this.infoForm.lastname}` : ''
            }`
          }
          add_corp_info({}, params)
            .then(() => {
              this.$emit('submit')
              this.$log.action('CC_SUBMIT_QUESTIONNAIRE', { data: params })
              this.visible = false
              localStorage.question = ''
            })
            .catch(() => {
              localStorage.question = ''
            })
        })
      } else {
        this.$emit('submit')
      }
    }
  }
}
